import { render, staticRenderFns } from "./JobRequestView.vue?vue&type=template&id=2073ff88&"
import script from "./JobRequestView.vue?vue&type=script&lang=js&"
export * from "./JobRequestView.vue?vue&type=script&lang=js&"
import style0 from "./JobRequestView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports